function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.4 3.56001V1C4.4 0.44 4.84 0 5.4 0C5.96 0 6.4 0.44 6.4 1V3.56001C6.4 4.12001 5.96 4.56001 5.4 4.56001C4.84 4.56001 4.4 4.12001 4.4 3.56001ZM13 4.56001C13.56 4.56001 14 4.12001 14 3.56001V1C14 0.44 13.56 0 13 0C12.44 0 12 0.44 12 1V3.56001C12 4.12001 12.44 4.56001 13 4.56001ZM18.4 2.27998V15.8C18.4 16.24 18.04 16.6 17.6 16.6H0.8C0.36 16.6 0 16.24 0 15.8V2.27998C0 1.83998 0.36 1.4 0.8 1.4H2.66001C3.10001 1.4 3.46001 1.76 3.46001 2.2C3.46001 2.64 3.10001 3 2.66001 3H1.58V6.4H16.78V3H15.72C15.28 3 14.92 2.64 14.92 2.2C14.92 1.76 15.28 1.4 15.72 1.4H17.58C18.04 1.4 18.4 1.83998 18.4 2.27998ZM16.8 15V7.8H1.6V15H16.8ZM7.93999 3H10.46C10.9 3 11.26 2.64 11.26 2.2C11.26 1.76 10.9 1.4 10.46 1.4H7.93999C7.49999 1.4 7.13999 1.76 7.13999 2.2C7.13999 2.64 7.49999 3 7.93999 3Z",
  fill: "#48671C"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/date.4205f30b.svg";
export { SvgComponent as ReactComponent };